
import styled from 'styled-components';


export const StyledClientDetail = styled.div`
  display: grid;
  grid-template-columns: 1fr 300px;
  height: 100dvh;
  
  @media (max-width: 1279px) {
    grid-template-columns: 1fr;
    height: auto;
  }
`;

export const StyledClientDetailOrders = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`;

export const StyledRight = styled.div`
  border-left: 1px solid #E0E0E0;
  padding: 30px;
  
  @media (max-width: 1279px) {
    border-left: 0;
    border-top: 1px solid #E0E0E0;
    padding: 20px 10px;
  }
`;

export const StyledMenu = styled.ul`
  display: flex;
  flex-wrap: wrap;
  row-gap: 4px;
  width: 100%;
  border-bottom: 1px solid #E0E0E0;
  list-style-type: none;
  margin: 0 0 20px 0;
  padding: 0 0 0 30px;
  
  li {
    display: inline-block;
    margin-right: 40px;
    border-bottom: 2px solid #fbfbfb;
    
    a {
      text-transform: uppercase;
      font-size: 14px;
      display: flex;
      align-items: center;
      height: 50px;
      line-height: 50px;
      color: #828282;
      font-weight: 500;
    }
    
    &.active {
      border-bottom: 2px solid #FEC108;
      a {
        color: #333333;
      }
    }
  }
  
  @media (max-width: 1279px) {
    padding: 0 0 0 10px;
    margin-bottom: 20px;
    
    li {
      margin-right: 24px;

      a {
        font-size: 13px;
        height: 44px;
        line-height: 44px;
      }
    }
  }
`;

export const StyledClientBlock = styled.div`
  div {
    display: inline-block;
    margin-right: 40px;
  }
  
  label {
    font-size: 12px;
    color: #828282;
    display: block;
    margin-bottom: 5px;
  }
  
  .personal_manager-icon {
    margin-right: 10px;
   
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;
      width: 36px;
      background: #E0E0E0;
      border-radius: 18px;
    }
  }
`;